import React from "react";

import Slider from "react-slick";

import "./cardportofolio.css";

export default function CardPortofolio() {
  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 5,
    autoplay: true,
    speed: 7000,
    // autoplaySpeed: 2000,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 834,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <>
      <div>
        <Slider {...settings}>
          <div className="itemPortofolio">
            <img
              src={require("../../assets/ahm.png")}
              className="img-fluid"
              alt="..."
              width={150}
            />
          </div>
          <div className="itemPortofolio">
            <img
              src={require("../../assets/yamaha.png")}
              className="img-fluid"
              alt="..."
              width={80}
            />
          </div>
          <div className="itemPortofolio">
            <img
              src={require("../../assets/MEGA.png")}
              className="img-fluid"
              alt="..."
              width={130}
            />
          </div>
          <div className="itemPortofolio">
            <img
              src={require("../../assets/neural.png")}
              className="img-fluid"
              alt="..."
              width={120}
            />
          </div>
          <div className="itemPortofolio">
            <img
              src={require("../../assets/sinar.png")}
              className="img-fluid"
              alt="..."
              width={200}
            />
          </div>
          <div className="itemPortofolio">
            <img
              src={require("../../assets/bankcapital.png")}
              className="img-fluid"
              alt="..."
              width={150}
            />
          </div>
          <div className="itemPortofolio">
            <img
              src={require("../../assets/dji.png")}
              className="img-fluid"
              alt="..."
              width={100}
            />
          </div>
          <div className="itemPortofolio">
            <img
              src={require("../../assets/ojk.png")}
              className="img-fluid"
              alt="..."
              width={150}
            />
          </div>
          <div className="itemPortofolio">
            <img
              src={require("../../assets/ipeka.png")}
              className="img-fluid"
              alt="..."
              width={100}
            />
          </div>
          <div className="itemPortofolio">
            <img
              src={require("../../assets/jebjes.png")}
              className="img-fluid"
              alt="..."
              width={200}
            />
          </div>
          <div className="itemPortofolio">
            <img
              src={require("../../assets/sspik.png")}
              className="img-fluid"
              alt="..."
              width={150}
            />
          </div>
          <div className="itemPortofolio">
            <img
              src={require("../../assets/pertamina.png")}
              className="img-fluid"
              alt="..."
              width={180}
            />
          </div>
          <div className="itemPortofolio">
            <img
              src={require("../../assets/samsung.png")}
              className="img-fluid"
              alt="..."
              width={200}
            />
          </div>
          <div className="itemPortofolio">
            <img
              src={require("../../assets/ibox.png")}
              className="img-fluid"
              alt="..."
              width={120}
            />
          </div>
          <div className="itemPortofolio">
            <img
              src={require("../../assets/cathay.png")}
              className="img-fluid"
              alt="..."
              width={200}
            />
          </div>
          <div className="itemPortofolio">
            <img
              src={require("../../assets/kemendagri.png")}
              className="img-fluid"
              alt="..."
              width={100}
            />
          </div>
          <div className="itemPortofolio">
            <img
              src={require("../../assets/nestle.png")}
              className="img-fluid"
              alt="..."
              width={110}
            />
          </div>
          <div className="itemPortofolio">
            <img
              src={require("../../assets/erafone.png")}
              className="img-fluid"
              alt="..."
              width={110}
            />
          </div>
          <div className="itemPortofolio">
            <img
              src={require("../../assets/foxs.png")}
              className="img-fluid"
              alt="..."
              width={110}
            />
          </div>
          <div className="itemPortofolio">
            <img
              src={require("../../assets/savoria.png")}
              className="img-fluid"
              alt="..."
              width={110}
            />
          </div>
          <div className="itemPortofolio">
            <img
              src={require("../../assets/goo.n.png")}
              className="img-fluid"
              alt="..."
              width={110}
            />
          </div>
          <div className="itemPortofolio">
            <img
              src={require("../../assets/tjetak.png")}
              className="img-fluid"
              alt="..."
              width={110}
            />
          </div>
          <div className="itemPortofolio">
            <img
              src={require("../../assets/home.png")}
              className="img-fluid"
              alt="..."
              width={110}
            />
          </div>
          <div className="itemPortofolio">
            <img
              src={require("../../assets/krizzi.png")}
              className="img-fluid"
              alt="..."
              width={110}
            />
          </div>
          <div className="itemPortofolio">
            <img
              src={require("../../assets/kin.png")}
              className="img-fluid"
              alt="..."
              width={70}
            />
          </div>
          <div className="itemPortofolio">
            <img
              src={require("../../assets/larutan.png")}
              className="img-fluid"
              alt="..."
              width={110}
            />
          </div>
        </Slider>
      </div>
    </>
  );
}
